function objectValuesWithId(inputObject) {
  return Object.keys(inputObject).map((key) => ({
    ...inputObject[key],
    id: key
    // +'-key',
  }));
}
export {
  objectValuesWithId as o
};
